module.exports = __webpack_public_path__ + "img/06.0805f0fb.png";